"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactI18next = require("react-i18next");
var _Modal = _interopRequireDefault(require("../common/Modal/Modal"));
var _APButton = _interopRequireDefault(require("../common/APButton"));
var _APLabelWithText = _interopRequireDefault(require("../common/APLabelWithText"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _numberFormatter = require("../../helpers/numberFormatter");
var _dateHelper = require("../../helpers/dateHelper");
var _APDatePicker = require("../common/APDatePicker/APDatePicker");
var _APReactSelect = require("../common/APReactSelect/APReactSelect");
var _i18nIsoCountries = _interopRequireDefault(require("i18n-iso-countries"));
var _en = _interopRequireDefault(require("i18n-iso-countries/langs/en.json"));
require("./TravelRuleDepositModal.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } // DEV-8959: Travel Rule deposit originator information modal
_i18nIsoCountries["default"].registerLocale(_en["default"]);
var countryOptions = Object.entries(_i18nIsoCountries["default"].getNames('en', {
  select: 'official'
})).map(function (_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
    alpha2 = _ref2[0],
    name = _ref2[1];
  return {
    value: _i18nIsoCountries["default"].alpha2ToAlpha3(alpha2),
    label: name
  };
}).sort(function (a, b) {
  return a.label.localeCompare(b.label);
});
var bemClasses = (0, _cssClassesHelper.getBEMClasses)('travel-rule-deposit-modal');
var SOURCE_TYPES = {
  EXCHANGE: 'exchange',
  PRIVATE_WALLET: 'private_wallet'
};
var TOP_EXCHANGES = [{
  value: 'Binance',
  label: 'Binance'
}, {
  value: 'Coinbase',
  label: 'Coinbase'
}, {
  value: 'Kraken',
  label: 'Kraken'
}, {
  value: 'Bitstamp',
  label: 'Bitstamp'
}, {
  value: 'Gemini',
  label: 'Gemini'
}, {
  value: 'Crypto.com',
  label: 'Crypto.com'
}, {
  value: 'KuCoin',
  label: 'KuCoin'
}, {
  value: 'Bybit',
  label: 'Bybit'
}, {
  value: 'OKX',
  label: 'OKX'
}, {
  value: 'Bitfinex',
  label: 'Bitfinex'
}, {
  value: 'Gate.io',
  label: 'Gate.io'
}, {
  value: 'Huobi',
  label: 'Huobi'
}, {
  value: 'Upbit',
  label: 'Upbit'
}, {
  value: 'Bithumb',
  label: 'Bithumb'
}, {
  value: 'Other',
  label: 'Other'
}];
var TravelRuleForm = function TravelRuleForm(_ref3) {
  var deposit = _ref3.deposit,
    close = _ref3.close,
    submitDepositTravelRuleInfo = _ref3.submitDepositTravelRuleInfo,
    t = _ref3.t;
  var _useState = (0, _react.useState)(SOURCE_TYPES.EXCHANGE),
    _useState2 = _slicedToArray(_useState, 2),
    sourceType = _useState2[0],
    setSourceType = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isSelfSender = _useState4[0],
    setIsSelfSender = _useState4[1];
  var _useState5 = (0, _react.useState)(''),
    _useState6 = _slicedToArray(_useState5, 2),
    exchangeName = _useState6[0],
    setExchangeName = _useState6[1];
  var _useState7 = (0, _react.useState)(''),
    _useState8 = _slicedToArray(_useState7, 2),
    senderFirstName = _useState8[0],
    setSenderFirstName = _useState8[1];
  var _useState9 = (0, _react.useState)(''),
    _useState0 = _slicedToArray(_useState9, 2),
    senderLastName = _useState0[0],
    setSenderLastName = _useState0[1];
  var _useState1 = (0, _react.useState)(null),
    _useState10 = _slicedToArray(_useState1, 2),
    senderDob = _useState10[0],
    setSenderDob = _useState10[1];
  var _useState11 = (0, _react.useState)(''),
    _useState12 = _slicedToArray(_useState11, 2),
    senderCountry = _useState12[0],
    setSenderCountry = _useState12[1];
  var onSourceTypeChange = (0, _react.useCallback)(function (type) {
    setSourceType(type);
    if (type === SOURCE_TYPES.PRIVATE_WALLET) {
      setExchangeName('');
    }
  }, []);
  var onSubmit = (0, _react.useCallback)(function () {
    submitDepositTravelRuleInfo({
      TicketId: deposit.TicketNumber,
      SourceType: sourceType,
      ExchangeName: sourceType === SOURCE_TYPES.EXCHANGE ? exchangeName : '',
      SenderFirstName: senderFirstName,
      SenderLastName: senderLastName,
      SenderDob: senderDob instanceof Date ? "".concat(senderDob.getFullYear(), "-").concat(String(senderDob.getMonth() + 1).padStart(2, '0'), "-").concat(String(senderDob.getDate()).padStart(2, '0')) : senderDob || '',
      SenderCountry: senderCountry || '',
      IsSelfSender: isSelfSender
    });
    close();
  }, [deposit, sourceType, exchangeName, senderFirstName, senderLastName, senderDob, senderCountry, isSelfSender, submitDepositTravelRuleInfo, close]);
  var isSubmitDisabled = (0, _react.useMemo)(function () {
    if (!senderFirstName || !senderLastName) return true;
    if (sourceType === SOURCE_TYPES.EXCHANGE && !exchangeName) return true;
    return false;
  }, [senderFirstName, senderLastName, sourceType, exchangeName]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('form')
  }, /*#__PURE__*/_react["default"].createElement("section", {
    className: bemClasses('deposit-info')
  }, /*#__PURE__*/_react["default"].createElement("h4", {
    className: bemClasses('section-title')
  }, t('Deposit Details')), /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: t('Asset'),
    text: deposit.AssetName,
    customClass: bemClasses()
  }), /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: t('Amount'),
    text: (0, _numberFormatter.formatNumberToLocale)(deposit.Amount),
    customClass: bemClasses()
  }), /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: t('Transaction ID'),
    text: deposit.TicketNumber,
    customClass: bemClasses()
  }), /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: t('Created'),
    text: (0, _dateHelper.formatDateTime)(deposit.CreatedTimestamp),
    customClass: bemClasses()
  })), /*#__PURE__*/_react["default"].createElement("section", {
    className: bemClasses('sender-info')
  }, /*#__PURE__*/_react["default"].createElement("h4", {
    className: bemClasses('section-title')
  }, t('Sender Information')), /*#__PURE__*/_react["default"].createElement("p", {
    className: bemClasses('description')
  }, t('To comply with Travel Rule regulations, please provide information about the sender of this deposit.')), /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('source-type')
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: bemClasses('source-type-label')
  }, t('Source Type')), /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('source-type-buttons')
  }, /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
    type: "button",
    styleName: sourceType === SOURCE_TYPES.EXCHANGE ? 'additive' : 'default',
    onClick: function onClick() {
      return onSourceTypeChange(SOURCE_TYPES.EXCHANGE);
    }
  }, t('Exchange')), /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
    type: "button",
    styleName: sourceType === SOURCE_TYPES.PRIVATE_WALLET ? 'additive' : 'default',
    onClick: function onClick() {
      return onSourceTypeChange(SOURCE_TYPES.PRIVATE_WALLET);
    }
  }, t('Private Wallet')))), sourceType === SOURCE_TYPES.EXCHANGE && /*#__PURE__*/_react["default"].createElement(_APReactSelect.InnerReactSelect, {
    input: {
      value: exchangeName,
      onChange: function onChange(value) {
        return setExchangeName(value);
      },
      onBlur: function onBlur() {}
    },
    options: TOP_EXCHANGES,
    valueAsObject: false,
    label: t('Exchange Name') + ' *',
    placeholder: t('Select an exchange'),
    isClearable: true,
    menuPlacement: "auto"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('self-sender-checkbox')
  }, /*#__PURE__*/_react["default"].createElement("input", {
    type: "checkbox",
    id: "isSelfSender",
    checked: isSelfSender,
    onChange: function onChange(e) {
      return setIsSelfSender(e.target.checked);
    }
  }), /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: "isSelfSender"
  }, t("I'm the sender"))), /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('field')
  }, /*#__PURE__*/_react["default"].createElement("label", null, t('Sender First Name'), " *"), /*#__PURE__*/_react["default"].createElement("input", {
    type: "text",
    value: senderFirstName,
    onChange: function onChange(e) {
      return setSenderFirstName(e.target.value);
    },
    placeholder: t('Enter first name')
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('field')
  }, /*#__PURE__*/_react["default"].createElement("label", null, t('Sender Last Name'), " *"), /*#__PURE__*/_react["default"].createElement("input", {
    type: "text",
    value: senderLastName,
    onChange: function onChange(e) {
      return setSenderLastName(e.target.value);
    },
    placeholder: t('Enter last name')
  })), /*#__PURE__*/_react["default"].createElement(_APDatePicker.DatePicker, {
    input: {
      value: senderDob,
      onChange: function onChange(date) {
        return setSenderDob(date);
      },
      onBlur: function onBlur() {}
    },
    meta: {
      touched: false,
      error: null,
      dirty: false
    },
    label: t('Sender Date of Birth (Optional)'),
    maxDate: new Date(),
    onClear: function onClear() {
      return setSenderDob(null);
    }
  }), /*#__PURE__*/_react["default"].createElement(_APReactSelect.InnerReactSelect, {
    input: {
      value: senderCountry,
      onChange: function onChange(value) {
        return setSenderCountry(value);
      },
      onBlur: function onBlur() {}
    },
    options: countryOptions,
    valueAsObject: false,
    label: t('Sender Country (Optional)'),
    placeholder: t('Select a country'),
    isClearable: true,
    menuPlacement: "auto"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('buttons')
  }, /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
    type: "button",
    styleName: "default",
    onClick: close
  }, t('Cancel')), /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
    type: "button",
    styleName: "additive",
    disabled: isSubmitDisabled,
    onClick: onSubmit
  }, t('Submit'))));
};
TravelRuleForm.propTypes = {
  deposit: _propTypes["default"].object.isRequired,
  close: _propTypes["default"].func.isRequired,
  submitDepositTravelRuleInfo: _propTypes["default"].func.isRequired,
  t: _propTypes["default"].func.isRequired
};
var TravelRuleDepositModalComponent = function TravelRuleDepositModalComponent(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)('order'),
    t = _useTranslation.t;
  var isOpen = props.isOpen,
    close = props.close,
    deposit = props.deposit,
    submitDepositTravelRuleInfo = props.submitDepositTravelRuleInfo;
  if (!isOpen || !deposit) return null;
  return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    isOpen: isOpen,
    title: t('Provide Sender Information'),
    close: close,
    customClass: bemClasses()
  }, /*#__PURE__*/_react["default"].createElement(TravelRuleForm, {
    key: deposit.TicketNumber,
    deposit: deposit,
    close: close,
    submitDepositTravelRuleInfo: submitDepositTravelRuleInfo,
    t: t
  }));
};
TravelRuleDepositModalComponent.propTypes = {
  isOpen: _propTypes["default"].bool,
  close: _propTypes["default"].func,
  deposit: _propTypes["default"].object,
  submitDepositTravelRuleInfo: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = TravelRuleDepositModalComponent;